import { render, staticRenderFns } from "./WorkPlaceMaintenance.vue?vue&type=template&id=6ae492fe"
import script from "./WorkPlaceMaintenance.vue?vue&type=script&lang=js"
export * from "./WorkPlaceMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae492fe')) {
      api.createRecord('6ae492fe', component.options)
    } else {
      api.reload('6ae492fe', component.options)
    }
    module.hot.accept("./WorkPlaceMaintenance.vue?vue&type=template&id=6ae492fe", function () {
      api.rerender('6ae492fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/BaseDataManage/WorkPlaceMaintenance.vue"
export default component.exports